module.exports = __webpack_public_path__ + "img/activity-cover.18632160.png";